import react, { useEffect, useState } from "react";
import { Step, Stepper } from "@progress/kendo-react-layout";
import {
  getProcessesDetails,
  getProcessesStatusList,
} from "../../../store/process/actions";
import { useDispatch, useSelector } from "react-redux";
// const items = [
// 	{
// 	  label: "Submitted",
// 	  //icon: "k-i-save",
// 	},
// 	{
// 	  label: "Cert Officer",

// 	  //icon: "k-i-signature",
// 	},
// 	{
// 	  label: "Appointing Auth",
// 	},
// 	{
// 	  label: "BBMR",
// 	},
// 	{
// 	  label: "Classification",// & Pay
// 	 // icon: "k-i-track-changes-accept",
// 	},
// 	  {
// 		label: "EMR",//Recruitment/Testing/
// 		//icon: "k-i-track-changes-accept",
// 	  },
// 	  {
// 		label: "Drug Testing",
// 		//icon: "k-i-track-changes-accept",
// 	  },
// 	  {
// 		label: "Records",
// 		//icon: "k-i-track-changes-accept",
// 	  },
// 	  {
// 		label: "Payroll",
// 		//icon: "k-i-track-changes-accept",
// 	  },
//   ];

const DepartmentsToSkipBBMR = [
  "GUAM LEGISLATURE",
  // "Public Defender Services Corporation", // we have PUBLIC DEFENDER, PUBLIC DEFENDER CORPORATION OF GUAM
  "JUDICIARY OF GUAM", //"Unified Judiciary of Guam" instead we have JUDICIARY OF GUAM 
  "MAYOR'S COUNCIL",
  "OFFICE OF PUBLIC ACCOUNTABILITY",
  "OFFICE OF THE ATTORNEY GENERAL",
  "GUAM MEMORIAL HOSPITAL AUTHORITY",
  "GUAM VISITOR'S BUREAU",
  // "University of Guam", // We don't have in list
  "GUAM COMMUNITY COLLEGE",
  "GUAM ELECTION COMMISSION",
  "GUAM ANCESTRAL LANDS COMMISSION",
  "CHAMORRO LAND TRUST COMMISSION",
  // "GUAM COMM. FOR EDUCATOR CERTIFICATION",
  "GSWA - GUAM SOLID WASTE AUTHORITY",
  "GWSA - GUAM SOLID WASTE AUTHORITY",
  "GUAM ETHICS COMMISSION",
]

const GG1Workflow = ({ currentValue, ProcessID, setRenderProcessFlow, noa, evaluation, toGrade, fromGrade, toDepartment, BBMRSkipLogin }) => {
  const {
    process,
    processStatusList,
    loadingProcessDetails,
    posting,
    postingResult,
    error,
  } = useSelector((state) => state.processReducer);
  const dispatch = useDispatch();
  const [value, setValue] = useState(0);
  const [data, setData] = useState([]);
  const [processStatusesForGG1, setprocessStatusesForGG1] = useState([]);
  const isNoaIgnoredForStatus = (ignoreNOA = "", noaValue = "") => {
    if (!ignoreNOA || !noaValue) return false;
    return ignoreNOA
      .toString()
      .split(",")
      .map((item) => item.trim())
      .includes(noaValue.toString().trim());
  };
  const shouldHideWorkflowStatus = (status) =>
    isNoaIgnoredForStatus(status?.ignoreNOA, noa);
  let dataRun = false;
  const handleChange = (e) => {
    // console.log("1212 stepper change ::: ", e, e.value, e.target.value);
    // setValue(e.value);
  };
  useEffect(() => {
    if (currentValue) {
      setRenderProcessFlow(true);
    } else {
      setRenderProcessFlow(false);
    }
  }, [currentValue]);
  useEffect(() => {
    if (ProcessID > 0 && currentValue) {
      dispatch(getProcessesStatusList(ProcessID));
    }
  }, [dispatch, ProcessID, currentValue]);
  useEffect(() => {
    let BBMRStatuses = [8,339,272,342,338]
    let PEStatues = [274,280,281]
    if (processStatusList && processStatusList.length) {
      let newArray
      let recordsSeq = processStatusList.find((item) => item.id == 19)?.seq;

      // if(noa == "38"){
      //   // debugger
      //   if(toGrade && toGrade?.trim()?.substring(0,2) != "E-"){
      //     console.log("121212 Succeeded",toGrade?.substring(0,2))
      //     newArray = processStatusList.filter((item) => item?.id != 301 && item.seq <= recordsSeq);
      //   }else{
      //     newArray = processStatusList.filter((item) => item.seq <= recordsSeq);
      //   }
      // }else 
      
      if(noa == "30" || noa == "58"){
        if(noa == "30"){
          if(currentValue == "18"){
            if(evaluation?.value == "S"){
              newArray = processStatusList.filter((item) => item.id == 18 || item.id == 19);
            }else{
              newArray = processStatusList.filter((item) => item.id == 18 || item.id == 10 || item.id == 19);
            }
          }else{
            newArray = processStatusList.filter((item) => item.id == 18 || item.id == 10 || item.id == 19);
          }
        }else{
          newArray = processStatusList.filter((item) => item.id == 18 || item.id == 10 || item.id == 19);
        }
      }
      else{
        console.log("111222 ::: ",currentValue)
        let currentVal = parseInt( currentValue ? currentValue?.toString(): "0")
        // if(toDepartment && toDepartment != "" && (DepartmentsToSkipBBMR.includes(toDepartment) || BBMRSkipLogin) && !BBMRStatuses.includes(currentVal))
        if(BBMRSkipLogin || (toDepartment && toDepartment != "" && DepartmentsToSkipBBMR.includes(toDepartment) && !BBMRStatuses.includes(currentVal)))
        {
          newArray = processStatusList.filter((item) => item.seq <= recordsSeq && !item?.parentId && !BBMRStatuses.includes(item.id));
        }
        else{
          if(processStatusList?.find((item)=>item?.statusName == "Office of Governor")){
            if((toGrade && toGrade?.trim()?.substring(0,2) == "E-") || 
              (fromGrade && fromGrade?.trim()?.substring(0,2) == "E-")
            ){
              newArray = processStatusList.filter((item) => item?.statusName != "Agency Director" && item.seq <= recordsSeq);
              // newArray = processStatusList.filter((item) => item?.id != 133 && item?.statusName != "Agency Director" && item.seq <= recordsSeq);
            }else{
              newArray = processStatusList.filter((item) => item?.statusName != "Office of Governor" && item.seq <= recordsSeq);
              // newArray = processStatusList.filter((item) => item?.id != 301 && item?.statusName != "Office of Governor" && item.seq <= recordsSeq);
            }
          }
          else{
            newArray = processStatusList.filter((item) => item.seq <= recordsSeq && !item?.parentId);
          }
        }

        if(PEStatues?.includes(currentValue)){
          newArray = processStatusList.filter((item) => item.seq <= recordsSeq && !item?.parentId);
        }
        // newArray = processStatusList.filter((item) => item.seq <= recordsSeq);
      }
      setprocessStatusesForGG1(
        (newArray || []).filter((item) => !shouldHideWorkflowStatus(item))
      );
    }
  }, [processStatusList, evaluation, toGrade, fromGrade, toDepartment, noa]);
  useEffect(() => {
    let PEStatues = [274,280,281]
    // debugger
    if (processStatusesForGG1 && processStatusesForGG1.length > 0) {
      setData(
        processStatusesForGG1.map((d) => {
          return { label: d?.statusName };
        })
      );
      // setTimeout(() => {
      let stepIndex = processStatusesForGG1.indexOf(
        processStatusesForGG1.find((d) => d.id === currentValue)
      );
      if(processStatusList.find((d) => d.id == currentValue)?.parentId == 338){
        stepIndex = processStatusesForGG1.indexOf(
          processStatusesForGG1.find((d) => d.id == 338)
        );
      }
      if(PEStatues?.includes(currentValue)){
        stepIndex = processStatusesForGG1.indexOf(
          processStatusesForGG1.find((d) => d.id == 19)
        );
      }
      setValue(stepIndex);
      // }, 1000);
    }
  }, [processStatusesForGG1]);
  if (!data || data.length === 0) return null;
  return (
    <>
      <Stepper value={value} items={data} disabled />
    </>
  );
};
export default GG1Workflow;
